<div id="tutorialModal" class="modal">
  <div class="vertical-alignment-helper">
    <div class="modal-dialog vertical-align-center">
      <div class="modal-content" [ngClass]="{'addHeight':pageNumber == 0}">
        <div class="row">
          <div class="col-md-12 desktop-show">
              <div *ngIf="pageNumber == 0">
                <img src="/assets/images/WellBrain.png" alt="WellBrain" class="logo" *ngIf="pageNumber == 0">
                <p class="text mainText text-lg description">Do Mindfulness Meditations and Exercises by optionally Using NeuroSky Device to validate and keep track of your progress when following your Doctor's prescription or exploring & self assigning Paths to follow by yourself</p>
              </div>
              <div *ngIf="pageNumber == 1">
                  <p>Do Mindfulness Meditations and Exercises <span class="txtOpacity">by</span></p>
                    <p class="txtOpacity">optionally using NeuroSky Device to validate and keep track of your progress when</p>
                  <div class="col-md-6">
                    <p class="text text-lg marginBottom20">WellBrain is all about letting you do Mindfulness Meditations and Exercises through our Apps or Website.</p>
                    <p class="marginBottom20">You will be able to pick from different type of meditations and choose the one that's best for you.</p>
                    <p class="marginBottom20">You'll be also able to do different types of Excercises, combined in Paths, depending on your medical needs.</p>
                  </div>
                  <div class="col-md-6">
                    <img src="/assets/images/tutorial-1.png" alt="tutorial" class="image img1Style">
                  </div>
              </div>
              <div *ngIf="pageNumber == 2">
                <p class="txtOpacity breakWord">optionally using NeuroSky Device to validate and keep track of your progress when</p>
                <p>following your Doctor's prescription <span class="txtOpacity">or</span></p>
                <p class="txtOpacity breakWord">exploring & self assigning Paths to follow by yourself</p>
                <div class="col-md-6">
                  <p class="text text-lg marginBottom20">The very concept of WellBrain is to let your Doctor assign a customized mindfulness prescription to you.</p>
                  <p>You will be asked to follow specific paths built out of Excercises. And of course you will be able to use NeuroSky to validate your progress.</p>
                </div>
                <div class="col-md-6">
                  <img src="/assets/images/tutorial3_new.png" alt="tutorial" class="image img3Style">
                </div>
              </div>
              <div *ngIf="pageNumber == 3">
                  <p class="txtOpacity breakWord">following your Doctor's prescription or</p>
                <p>exploring & self assigning Paths to follow by yourself</p>
                <div class="col-md-6">
                  <p class="text text-lg marginBottom20">You can browse all the available paths by clicking on the PATHS button from the main navigation.</p>
                  <p class="marginBottom20">After entering a path of your choice, you'll see the "Assign to me" button at the top.</p>
                  <p>Once you Slef-Assign a path, it will be listed under MY PATHS in the PATHS section.</p>
                </div>
                <div class="col-md-6">
                  <img src="/assets/images/tutorial2_New.png" alt="tutorial" class="image image2Style">
                </div>
              </div>
          </div>
          <div class="col-md-12 mobile-show">
              <div *ngIf="pageNumber == 0">
                  <img src="/assets/images/WellBrain.png" alt="WellBrain" class="logo" *ngIf="pageNumber == 0">
                  <p class="text text-lg description">Do Mindfulness Meditations and Exercises by optionally using NeuroSky Device to validate and keep track of your progress when following your Doctor's prescription or exploring & self assigning Paths to follow by yourself</p>
              </div>
              <div *ngIf="pageNumber == 1">
                  <p>Do Mindfulness Meditations and Exercises </p>
                  <div class='screen2'>by optionally using NeuroSky Device</div>
                  <img src="/assets/images/tutorial-10.png" alt="tutorial" class="image">
                  <p class="text text-lg">WellBrain is all about letting you do Mindfulness Meditations and Exercises through our Apps or Website.</p>
                  <p>You will be able to pick from different type of</p>
                </div>
                <div *ngIf="pageNumber == 2">
                  <p>progress when following your Doctor's prescription or exploring & self assigning Paths to</p>
                  <img src="/assets/images/tutorial-8.png" alt="tutorial" class="image">
                  <p class="text text-lg">The very concept of WellBrain is to let your Doctor assign a customized mindfulness prescription to you.</p>
                  <p>You will be asked to follow specific paths built</p>
                </div>
                <div *ngIf="pageNumber == 3">
                  <p>exploring & self assigning Paths to follow by yourself</p>
                  <img src="/assets/images/tutorial-7.png" alt="tutorial" class="image">
                  <p class="text text-lg">You can browse all the available paths by clicking on the PATHS button from the main navigation.</p>
                  <p>After entering a path of your choice. you'll see</p>
                </div>
          </div>
        </div>
        <div class="row footer" [ngClass]="{'footer-align':pageNumber !=0, 'footer-row':pageNumber ==0}" >
            <div class="col-md-9" *ngIf="pageNumber == 0">
              <button class="btn btn-lg btn-primary" (click)="navigate()">SHOW ME REAL QUICK</button>
              <button class="btn btn-block btn-lg" (click)="navigate('close')">Maybe next time</button>
            </div>
            <div class="col-md-3" *ngIf="pageNumber == 0"><img src="/assets/images/tutorial_userNew.png" alt="user" class="tutorial-user desktop-show" ><img src="/assets/images/tutorial_user.png" alt="user" class="tutorial-user mobile-show" ></div>
            <button class="btn btn-lg btn-primary"  *ngIf="pageNumber != 0" (click)="navigate()">Next<i class="fa fa-arrow-right"></i></button>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/components/tutorial/tutorial.component.html